 <template>
  <div class="custom-checkbox">
    <div class="">
      <div class="pills-container">
        <button
          class="pills-check-btn"
          :class="{ active: checked }"
          :disabled="false"
          :style="{ borderColor: border }"
          @click="
            (e) => {
              checkboxClick(id, title);
            }
          "
        >
          {{ title }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PillsCheck",
  props: {
    title: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    checked: Boolean,
    disabled: Boolean,
    items: {
      type: Array,
      default: () => [],
    },
    item_ids: {
      type: Array,
      default: () => [],
    },
    border: {
      type: String,
      default: "#00d09c",
    },
  },
  data() {
    return {
      isActive: false,
      searchText: "",
    };
  },
  methods: {
    checkboxClick(id, name) {
      this.$emit("checkbox-click", id, name);
    },
    subCheckboxClick(id, name) {
      this.$emit("sub-checkbox-click", id, name);
    },
  },
};
</script>
<style>
/* .pills-container {
  display: flex !important;
  align-items: center;
} */
.pills-check-btn {
  background-color: #fff;
  border: 1px solid;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  color: #224e80;
}
.pills-check-btn {
  background-color: #fff;

  background-size: 200% auto;
  background-position: 0% 100%;
  transition: background-position 0.3s ease-out;
}

.pills-check-btn.active {
  background-position: 100% 100%;
  color: #f4ffff;
  background-image: linear-gradient(135deg, #5367ff, #00d09c);
}
</style>



// WEBPACK FOOTER //
// src/components/forms/MultistepFormForFinder/PillsCheck.vue